/**
 * Use this instead of `Element.scrollIntoView`, because Safari doesn't
 * support options via that method.
 */
export const scrollIntoViewY = (element: HTMLElement, options: Options) => {

    const { behavior, onlyIfNeeded } = options;
    const boundingRect = element.getBoundingClientRect();

    if (onlyIfNeeded && window.innerHeight > boundingRect.bottom) {
        return;
    }

    const scrollTo = boundingRect.bottom - window.innerHeight;
    window.scrollTo({ top: scrollTo + window.scrollY, behavior: behavior });
};

type Options = {
    onlyIfNeeded: boolean;
    behavior: ScrollBehavior;
};